import React from 'react'

    const getLocalStorage = () =>{
        let totalScore = localStorage.getItem('totalScore');
        if(totalScore){
          return JSON.parse(localStorage.getItem('totalScore'))
        }else{
          return []
        }
      }

   
export default getLocalStorage;